"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssigneePerformanceService = void 0;
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var base_service_1 = require("../base.service");
var api_constants_1 = require("../../constants/api.constants");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var isUndefined_1 = __importDefault(require("lodash/isUndefined"));
var __1 = require("../..");
var AssigneePerformanceService = /** @class */ (function (_super) {
    __extends(AssigneePerformanceService, _super);
    function AssigneePerformanceService(options, assigneePerformanceClient, wwAssigneePerformanceClient, userService) {
        var _this = _super.call(this, options) || this;
        _this.assigneePerformanceClient = assigneePerformanceClient;
        _this.wwAssigneePerformanceClient = wwAssigneePerformanceClient;
        _this.userService = userService;
        return _this;
    }
    AssigneePerformanceService.newInstance = function (options) {
        var clientOptions = {
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        };
        return new AssigneePerformanceService(options, insync_assess_sdk_1.AssigneePerformanceClient.newInstance(clientOptions), insync_assess_sdk_1.WWAssigneePerformanceClient.newInstance(clientOptions), __1.UserService.newInstance(options));
    };
    /**
     * Retrieves the performance assignees by classes and template for W&W
     * @param classes                 - classes to show
     * @param assessmentTemplate      - assessment template data
     * @param {number} limit          - indicates the number of students to display
     * @param {Assessment} assessment - assessement instance to filter
     */
    AssigneePerformanceService.prototype.getAssigneesPerformancesByClassAndTemplate = function (classes, assessmentTemplate, limit, assessment) {
        return __awaiter(this, void 0, void 0, function () {
            var classIds, filters, assigneesPerformance, usersIds, users, _a, assigneesPerformanceWW;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        classIds = classes.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        filters = !(0, isUndefined_1.default)(assessment) ? { assessmentId: assessment.id } : undefined;
                        return [4 /*yield*/, this.assigneePerformanceClient.findByContextAndTemplate(classIds, [assessmentTemplate.id], __1.AssigneePerformanceGroupBy.ItemQuestion, filters, this.getDefaultHeaders())];
                    case 1:
                        assigneesPerformance = _b.sent();
                        usersIds = assigneesPerformance.map(function (performance) { return performance.assigneeId; });
                        if (!!(0, isEmpty_1.default)(usersIds)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.userService.findByIds(usersIds, true, true)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = [];
                        _b.label = 4;
                    case 4:
                        users = _a;
                        assigneesPerformanceWW = this.getAssigneesPerformanceWW(users, assessmentTemplate, assigneesPerformance, limit);
                        assigneesPerformanceWW.sort(function (a, b) {
                            return (a.assignee.lastName > b.assignee.lastName ? 1 : a.assignee.lastName === b.assignee.lastName)
                                ? 0
                                : -1;
                        });
                        return [2 /*return*/, assigneesPerformanceWW];
                }
            });
        });
    };
    /**
     * Retrieves the performance assignees by classes and template for W&W Vocabulary Assessment
     * @param {Class[]} classes         - classes to show
     * @param {Assessment} assessment   - assessement instance to filter
     * @param {number} limit            - indicates the number of students to display
  
     */
    AssigneePerformanceService.prototype.getAssigneesPerformancesVocabularyByClassAndTemplate = function (classes, assessment, limit) {
        return __awaiter(this, void 0, void 0, function () {
            var classIds, assigneesPerformance, usersIds, users, _a, assigneesPerformanceWW;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        classIds = classes.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.wwAssigneePerformanceClient.findVocabByContextAndAssessment(classIds, [assessment.id], this.getDefaultHeaders())];
                    case 1:
                        assigneesPerformance = _b.sent();
                        usersIds = assigneesPerformance.map(function (performance) { return performance.assigneeId; });
                        if (!!(0, isEmpty_1.default)(usersIds)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.userService.findByIds(usersIds, true, true)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = [];
                        _b.label = 4;
                    case 4:
                        users = _a;
                        assigneesPerformanceWW = this.getAssigneesPerformanceVocabularyWW(users, assigneesPerformance, limit);
                        assigneesPerformanceWW.sort(function (a, b) {
                            return (a.assignee.lastName > b.assignee.lastName ? 1 : a.assignee.lastName === b.assignee.lastName)
                                ? 0
                                : -1;
                        });
                        return [2 /*return*/, assigneesPerformanceWW];
                }
            });
        });
    };
    /**
     * It returns the Overall Assignees Performance data.
     * @param assigneesPerformance
     * @param assessmentTemplate
     */
    AssigneePerformanceService.prototype.getOverallAssigneesPerformanceWW = function (assigneesPerformance, assessmentTemplate) {
        var _this = this;
        var questions = __1.AssessmentTemplate.findQuestions(assessmentTemplate.items);
        var overallMaxScore = assigneesPerformance.reduce(function (total, performance) { return total + performance.maxScore; }, 0) /
            assigneesPerformance.length;
        var overallScore = assigneesPerformance.reduce(function (total, performance) { return total + performance.score; }, 0) /
            assigneesPerformance.length;
        var overallPercentage = this.calculatePercentage(overallScore, overallMaxScore);
        var overallItemQuestionsPerformance = [];
        questions.forEach(function (_a) {
            var externalId = _a.externalId;
            overallItemQuestionsPerformance.push(_this.getOverallItemQuestionPerformanceWW(assigneesPerformance, externalId));
        });
        return new __1.AssigneePerformanceWW({
            maxScore: overallMaxScore,
            score: overallScore,
            overallPercentage: overallPercentage,
            itemQuestionsPerformance: overallItemQuestionsPerformance.filter(function (_a) {
                var maxScore = _a.maxScore;
                return maxScore !== 0;
            }),
        });
    };
    /**
     * Overall Assignee Performances
     * @param {AssigneePerformance[]}            assigneePerformances              - Assignees Performances
     * @param {AssessmentTemplate}               assessmentTemplate                - Assessment Template
     */
    AssigneePerformanceService.prototype.getOverallAssigneesPerformanceByQuestion = function (assigneePerformances, assessmentTemplate) {
        var _this = this;
        var items = __1.AssessmentTemplate.findQuestions(assessmentTemplate.items);
        var overallMaxScore = assigneePerformances.reduce(function (total, performance) { return total + performance.maxScore; }, 0) /
            assigneePerformances.length;
        var overallScore = assigneePerformances.reduce(function (total, performance) { return total + performance.score; }, 0) /
            assigneePerformances.length;
        var overallPercentage = this.calculatePercentage(overallScore, overallMaxScore);
        var isAttempted = false;
        var overallItemPerformances = items.map(function (questionFromAssessment) {
            var itemPerformanceData = [];
            assigneePerformances.forEach(function (assignee) {
                var itemQuestionPerfomance = assignee.itemQuestionsPerformance.find(function (_a) {
                    var externalQuestionId = _a.externalQuestionId;
                    return externalQuestionId === questionFromAssessment.externalId;
                });
                if (itemQuestionPerfomance) {
                    itemPerformanceData.push(itemQuestionPerfomance);
                }
                if (!isAttempted) {
                    isAttempted = !!assignee.itemQuestionsPerformance.find(function (_a) {
                        var attempted = _a.attempted;
                        return attempted;
                    });
                }
            });
            var itemScore = itemPerformanceData.reduce(function (total, performance) { return total + performance.score; }, 0) /
                assigneePerformances.length;
            var itemMaxScore = itemPerformanceData.reduce(function (total, performance) { return total + performance.maxScore; }, 0) /
                assigneePerformances.length;
            return new __1.ItemQuestionPerformance({
                score: itemScore,
                maxScore: itemMaxScore,
                percentage: _this.calculatePercentage(itemScore, itemMaxScore),
                itemExternalId: questionFromAssessment.externalId,
            });
        });
        return new __1.AssigneePerformanceWW({
            score: overallScore,
            maxScore: overallMaxScore,
            overallPercentage: overallPercentage,
            itemQuestionsPerformance: overallItemPerformances.filter(function (_a) {
                var maxScore = _a.maxScore;
                return maxScore !== 0;
            }),
            attempted: isAttempted,
        });
    };
    /**
     * Overall Assignee Performances for Vocabulary Assessments
     * @param {AssigneePerformance[]}     assigneePerformances     - Assignees Performances
     * @param {AssessmentTemplate}        assessmentTemplate       - Assignees Performances
     */
    AssigneePerformanceService.prototype.getOverallAssigneesPerformanceByWord = function (assigneePerformances, assessmentTemplate) {
        var wordsCount = assessmentTemplate.items[0].maxScore;
        var overallWordPerformances = [];
        var _loop_1 = function (i) {
            var overallWordScore = 0;
            assigneePerformances.forEach(function (performance) {
                var _a;
                if ((_a = performance.itemWordsPerformance[i]) === null || _a === void 0 ? void 0 : _a.isCorrect)
                    overallWordScore++;
            });
            var overallWordMaxScore = assigneePerformances.length;
            var overallWordPercentage = this_1.calculatePercentage(overallWordScore, overallWordMaxScore);
            overallWordPerformances.push(new __1.ItemWordPerformance({
                score: overallWordScore,
                maxScore: overallWordMaxScore,
                percentage: overallWordPercentage,
            }));
        };
        var this_1 = this;
        for (var i = 0; i < wordsCount; i++) {
            _loop_1(i);
        }
        var overallScore = this.calculateScore(assigneePerformances);
        var overallMaxScore = this.calculateMaxScore(assigneePerformances);
        var overallPercentage = this.calculatePercentage(overallScore, overallMaxScore);
        return new __1.AssigneePerformanceWW({
            score: overallScore,
            maxScore: overallMaxScore,
            overallPercentage: overallPercentage,
            itemWordsPerformance: overallWordPerformances,
            attempted: !!assigneePerformances.find(function (i) { return i.itemWordsPerformance.length > 0; }),
        });
    };
    /**
     * It returns AssigneePerformanceWW data. It matches the order of
     * questions based on the assessment template.
     * @param users
     * @param assessmentTemplate
     * @param assigneesPerformance
     * @param limit
     */
    AssigneePerformanceService.prototype.getAssigneesPerformanceWW = function (users, assessmentTemplate, assigneesPerformance, limit) {
        var _this = this;
        var items = __1.AssessmentTemplate.findCoreItems([assessmentTemplate]);
        var questions = __1.AssessmentTemplate.findQuestions(items);
        return users
            .map(function (user) {
            var assigneePerformanceDto = assigneesPerformance.find(function (a) { return a.assigneeId === user.id; });
            if (assigneePerformanceDto) {
                var itemQuestionsPerformanceDto = assigneePerformanceDto.itemQuestionsPerformance
                    ? assigneePerformanceDto.itemQuestionsPerformance
                    : [];
                var score = itemQuestionsPerformanceDto.reduce(function (total, performance) { return total + performance.score; }, 0);
                var maxScore = itemQuestionsPerformanceDto.reduce(function (total, performance) { return total + performance.maxScore; }, 0);
                var overallPercentage = _this.calculatePercentage(score, maxScore);
                var attempts = _this.calculateAttemptsNumber(itemQuestionsPerformanceDto, assessmentTemplate);
                return new __1.AssigneePerformanceWW({
                    assignee: user,
                    attempts: attempts,
                    itemQuestionsPerformance: _this.getItemQuestionsPerformance(itemQuestionsPerformanceDto, questions).filter(function (item) { return item.maxScore !== 0; }),
                    maxScore: maxScore,
                    overallPercentage: overallPercentage,
                    score: score,
                    classId: assigneePerformanceDto.contextId,
                });
            }
            return new __1.AssigneePerformanceWW();
        })
            .filter(function (assignee) { return assignee.assignee; })
            .slice(0, limit || users.length);
    };
    /**
     * It returns AssigneePerformanceWW models based on DTOs data for Vocabulary assessments.
     * @param users
     * @param assigneesPerformance
     * @param limit
     */
    AssigneePerformanceService.prototype.getAssigneesPerformanceVocabularyWW = function (users, assigneesPerformance, limit) {
        var _this = this;
        return users
            .map(function (user) {
            var assigneePerformanceDto = assigneesPerformance.find(function (a) { return a.assigneeId === user.id; });
            if (assigneePerformanceDto) {
                var itemWordsPerformanceDto = assigneePerformanceDto.responses
                    ? assigneePerformanceDto.responses
                    : [];
                var itemWordsPerformance = itemWordsPerformanceDto.map(function (_a) {
                    var isCorrect = _a.isCorrect, key = _a.key;
                    return new __1.ItemWordPerformance({
                        key: key + 1,
                        isCorrect: isCorrect,
                    });
                });
                var score = itemWordsPerformanceDto.filter(function (_a) {
                    var isCorrect = _a.isCorrect;
                    return isCorrect;
                }).length;
                var maxScore = itemWordsPerformanceDto.length;
                var overallPercentage = _this.calculatePercentage(score, maxScore);
                return new __1.AssigneePerformanceWW({
                    assignee: user,
                    itemWordsPerformance: itemWordsPerformance,
                    score: score,
                    maxScore: maxScore,
                    overallPercentage: overallPercentage,
                    classId: assigneePerformanceDto.contextId,
                });
            }
            return new __1.AssigneePerformanceWW();
        })
            .filter(function (_a) {
            var assignee = _a.assignee;
            return assignee;
        })
            .slice(0, limit || users.length);
    };
    /**
     * Converts a list ItemQuestionPerformanceDto to ItemQuestionPerformance model
     * @param itemQuestionsPerformanceDto[]
     * @param questions[]
     */
    AssigneePerformanceService.prototype.getItemQuestionsPerformance = function (itemQuestionsPerformanceDto, questions) {
        var _this = this;
        return questions.map(function (question) {
            var itemQuestionPerformanceDto = itemQuestionsPerformanceDto.find(function (_a) {
                var externalQuestionId = _a.externalQuestionId;
                return externalQuestionId === question.externalId;
            });
            if (itemQuestionPerformanceDto) {
                var _a = itemQuestionPerformanceDto || {}, _b = _a.maxScore, maxScore = _b === void 0 ? 0 : _b, _c = _a.score, score = _c === void 0 ? 0 : _c;
                var percentage = _this.calculatePercentage(score, maxScore);
                var externalQuestionId = itemQuestionPerformanceDto.externalQuestionId, attempted = itemQuestionPerformanceDto.attempted;
                return new __1.ItemQuestionPerformance({
                    externalQuestionId: externalQuestionId,
                    maxScore: maxScore,
                    score: score,
                    percentage: percentage,
                    attempted: attempted,
                });
            }
            return new __1.ItemQuestionPerformance();
        });
    };
    /**
     * Retrieves the assessment performances by class and templates for and specific student and standard.
     * @param student                - student
     * @param classId                - class id
     * @param assessmentTemplates    - assessment templates list
     * @param assessments            - assessment list
     * @param standard               - standard
     */
    AssigneePerformanceService.prototype.getStudentAssessmentPerformancesByClassAndTemplateAndStandard = function (student, classId, assessmentTemplates, assessments, standard, standardHierarchyLevel) {
        return __awaiter(this, void 0, void 0, function () {
            var templateIds, assigneeAssessmentsPerformances;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        templateIds = assessmentTemplates.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.assigneePerformanceClient.findByContextAndTemplateAndAssignee(classId, templateIds, student.id, this.getDefaultHeaders())];
                    case 1:
                        assigneeAssessmentsPerformances = _a.sent();
                        return [2 /*return*/, assigneeAssessmentsPerformances
                                .map(function (performance) {
                                return _this.buildAssessmentPerformance(performance, assessments, standard, standardHierarchyLevel);
                            })
                                .filter(function (_a) {
                                var items = _a.items;
                                return items.length !== 0;
                            })];
                }
            });
        });
    };
    /**
     * Returns the Overall Item Question Performance data.
     * @param assigneesPerformance[]
     * @param questionId
     */
    AssigneePerformanceService.prototype.getOverallItemQuestionPerformanceWW = function (assigneesPerformance, questionId) {
        var overallScore = 0;
        var itemQuestionMaxScore = 0;
        assigneesPerformance.forEach(function (performance) {
            var found = performance.itemQuestionsPerformance.find(function (_a) {
                var externalQuestionId = _a.externalQuestionId;
                return externalQuestionId === questionId;
            });
            if (found) {
                overallScore += found.score === found.maxScore ? 1 : 0;
                itemQuestionMaxScore += found.maxScore;
            }
        });
        var overallMaxScore = itemQuestionMaxScore / assigneesPerformance.length;
        var overallPercentage = this.calculatePercentage(overallScore, overallMaxScore);
        return new __1.ItemQuestionPerformance({
            maxScore: overallMaxScore,
            score: overallScore,
            percentage: overallPercentage,
            itemExternalId: questionId,
        });
    };
    /**
     * Returns the percentage based on the provided data, if maxScore is 0 it returns 0
     * @param score
     * @param maxScore
     */
    AssigneePerformanceService.prototype.calculatePercentage = function (score, maxScore) {
        if (score === void 0) { score = 0; }
        if (maxScore === void 0) { maxScore = 0; }
        return maxScore ? (score / maxScore) * 100 : 0;
    };
    /**
     * Returns total of attempts based on assessment template and itemQuestionsPerformances
     * @param itemQuestionPerformanceDto[]
     */
    AssigneePerformanceService.prototype.calculateAttemptsNumber = function (itemQuestionsPerformanceDto, assessmentTemplate) {
        var attempts = 0;
        var items = __1.AssessmentTemplate.findCoreItems([assessmentTemplate]);
        var questions = __1.AssessmentTemplate.findQuestions(items);
        itemQuestionsPerformanceDto.forEach(function (_a) {
            var externalQuestionId = _a.externalQuestionId, _b = _a.maxScore, maxScore = _b === void 0 ? 0 : _b;
            var originalQuestion = questions.find(function (_a) {
                var externalId = _a.externalId;
                return externalId === externalQuestionId;
            });
            if (originalQuestion) {
                attempts = maxScore / originalQuestion.maxScore;
            }
        });
        return attempts;
    };
    /**
     * Returns average score of assignee performance list
     * @param assigneePerformances     - assignees performances
     */
    AssigneePerformanceService.prototype.calculateScore = function (assigneePerformances) {
        return (assigneePerformances.reduce(function (total, _a) {
            var score = _a.score;
            return total + score;
        }, 0) /
            assigneePerformances.length);
    };
    /**
     * Returns average max score of assignee performance list
     * @param assigneePerformances     - assignees performances
     */
    AssigneePerformanceService.prototype.calculateMaxScore = function (assigneePerformances) {
        return (assigneePerformances.reduce(function (total, _a) {
            var maxScore = _a.maxScore;
            return total + maxScore;
        }, 0) /
            assigneePerformances.length);
    };
    /**
     * builds Assessment Performance
     * @param assigneeAssessmentPerformance     - assigneeAssessmentPerformanceDto
     * @param assessments                       - assessments array
     */
    AssigneePerformanceService.prototype.buildAssessmentPerformance = function (assigneeAssessmentPerformance, assessments, standard, standardHierarchyLevel) {
        var assessment = assessments.find(function (_a) {
            var id = _a.id;
            return id === assigneeAssessmentPerformance.assessmentId;
        });
        var allItemsPerformances = assigneeAssessmentPerformance.itemsPerformance && assessment
            ? this.getItemsPerformance(assigneeAssessmentPerformance.itemsPerformance, __1.AssessmentTemplate.findCoreItems([assessment.assessmentTemplate]))
            : [];
        var itemsByStandard = __1.ItemPerformance.itemsPerformanceByStandardFromMicroApp(standard, standardHierarchyLevel, allItemsPerformances);
        var score = (itemsByStandard === null || itemsByStandard === void 0 ? void 0 : itemsByStandard.reduce(function (totalItems, itemPerformance) { return totalItems + itemPerformance.score; }, 0)) || 0;
        var maxScore = (itemsByStandard === null || itemsByStandard === void 0 ? void 0 : itemsByStandard.reduce(function (totalItems, itemPerformance) { return totalItems + itemPerformance.maxScore; }, 0)) || 0;
        return new __1.AssessmentPerformance({
            assessment: assessment,
            maxScore: maxScore,
            score: score,
            percentage: this.calculatePercentage(score, maxScore),
            items: !(0, isEmpty_1.default)(itemsByStandard) ? itemsByStandard.map(function (_a) {
                var item = _a.item;
                return item.externalId;
            }) : [],
        });
    };
    /**
     * builds Items Performance
     * @param itemsPerformance     - ItemPerformanceDto
     * @param items                - items array
     */
    AssigneePerformanceService.prototype.getItemsPerformance = function (itemsPerformance, items) {
        var _this = this;
        return items.map(function (item, itemIndex) {
            var performance = itemsPerformance.find(function (_a) {
                var itemExternalId = _a.itemExternalId;
                return itemExternalId === item.externalId;
            });
            var _a = performance || {}, _b = _a.maxScore, maxScore = _b === void 0 ? 0 : _b, _c = _a.score, score = _c === void 0 ? 0 : _c;
            var percentage = _this.calculatePercentage(score, maxScore);
            var index = itemIndex + 1;
            return new __1.ItemPerformance({
                item: item,
                percentage: percentage,
                maxScore: maxScore,
                score: score,
                index: index,
                attempted: !!performance,
            });
        });
    };
    return AssigneePerformanceService;
}(base_service_1.BaseService));
exports.AssigneePerformanceService = AssigneePerformanceService;
